import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { prop } from 'ramda';
import { getURLParams } from 'js/utils/url.util';
import { useGameConfig } from 'js/components/common/Game';
import { useAppSelector, useDeviceSelector, useUserSelector } from 'js/store/hooks';

export const useFormatterParams = () => {
    const { search } = useLocation();
    const { gameCode: gameCodeFromRouterParams } = useParams();
    const { game, gameCode: gameCodeFromUrl, gameType: gameTypeFromUrl } = getURLParams(search);
    const gameCode = gameCodeFromRouterParams || game || gameCodeFromUrl;
    const { gameType: gameTypeFromConf } = useGameConfig(gameCode);
    const gameType = gameTypeFromConf || gameTypeFromUrl;

    const lang = useUserSelector(prop('lang'));
    const clientType = useAppSelector(prop('clientType'));
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));

    return useMemo(() => ({
        gameCode,
        gameType,
        clientType,
        clientPlatform,
        language: lang
    }), [lang, gameCode, gameType, clientType, clientPlatform]);
};
